// NavBar.js

import React, { useState, useEffect } from 'react';
import './NavBar.css';

function NavBar() {
  const subtitleArray = [
    {
      text: "Identify the farming region specific to your location",
      icon: "fa-globe"
    },
    {
      text: "Identify the soil types specific to your location",
      icon: "fa-seedling"
    },
    {
      text: "Explore crops suitable for cultivation in your region",
      icon: "fa-leaf"
    },
    {
      text: "Explore crops' harvesting and planting times",
      icon: "fa-calendar"
    }
  ];
  

  const [subtitleIndex, setSubtitleIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSubtitleIndex((prevIndex) => (prevIndex + 1) % subtitleArray.length);
    }, 3000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-text">
          <div className="navbar-title">Crop Calendar</div>
          <div className="navbar-subtitle">
            <i className={`fas ${subtitleArray[subtitleIndex].icon}`}></i> {subtitleArray[subtitleIndex].text}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
